import apiService from '../../apiService';

const GROUP_URL = 'crm/crm_groups';

const groupService = {
  async getAllCrmGroups(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`${GROUP_URL}${queryParams ? `?${queryParams}` : ''}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getSingleCrmGroup(crmGroupId) {
    try {
      const response = await apiService.get(`${GROUP_URL}/${crmGroupId}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getCrmGroupContacts(crmGroupId) {
    try {
      const response = await apiService.get(`${GROUP_URL}/${crmGroupId}/contacts`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // The contact table on the group page: one page of contacts a campaign can reach.
  async getGroupContactOptions(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`crm/group_contacts?${queryParams}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Every contact matching the same filters, for "select all matching".
  async getAllGroupContactOptions(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`crm/group_contacts/all?${queryParams}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async createCrmGroup(payload) {
    try {
      const response = await apiService.post(`${GROUP_URL}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateCrmGroup(crmGroupId, payload) {
    try {
      const response = await apiService.put(`${GROUP_URL}/${crmGroupId}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteCrmGroup(crmGroupId) {
    try {
      const response = await apiService.delete(`${GROUP_URL}/${crmGroupId}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

};

export default groupService;